<script lang="ts">
	import CardBadge from '$lib/components/ui/CardBadge.svelte';
	import ImageHoverGallery from '$lib/components/ui/ImageHoverGallery.svelte';
	import { Importance } from '$lib/features/_other/importance.enum';
	import type { CityFeaturePreview } from '$lib/features/cityFeature/cityFeature.type';
	import type { NavLink } from '$lib/utils/url.util';
	import { fly } from 'svelte/transition';
	import IconArrowRight from '~icons/mdi/arrow-right';
	import IconStarFourPoints from '~icons/mdi/star-four-points';

	const { feature, nav }: { feature: CityFeaturePreview; nav: NavLink } = $props();

	let isCardHovered = $state<boolean>(false);
</script>

<a
	class="group relative block aspect-4/3 w-full overflow-hidden rounded-box shadow-lg transition-all duration-500 hover:-translate-y-1"
	title="View more about {feature.englishName}"
	href={`/${nav.href}`}
	data-sveltekit-preload-data={nav.preloadData}
	data-sveltekit-preload-code={nav.preloadCode}
>
	<div class="absolute inset-0 bg-base-300">
		<ImageHoverGallery images={feature.images} eagerLoading={false} onHoverChange={(isHovered) => (isCardHovered = isHovered)} />
	</div>

	{#if !isCardHovered}
		{@render Gradient()}
	{/if}

	<div class="pointer-events-none absolute inset-0 flex flex-col justify-end p-6 text-white">
		{#if feature.importance === Importance.ESSENTIAL && !isCardHovered}
			<div class="absolute top-3 right-3" in:fly={{ y: 20, duration: 300 }} out:fly={{ y: 20, duration: 300 }}>
				<CardBadge text="MUST SEE" Icon={IconStarFourPoints} />
			</div>
		{/if}

		{#if !isCardHovered}
			<div
				class="flex transform flex-col gap-2 transition-transform duration-500 group-hover:-translate-y-2"
				in:fly={{ y: 20, duration: 300 }}
				out:fly={{ y: 20, duration: 300 }}
			>
				<h3 class="text-md line-clamp-2 leading-tight">
					{feature.englishName}
				</h3>
			</div>
		{/if}
		<div
			class="absolute right-6 bottom-6 translate-y-8 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100"
		>
			{@render CtaBtn()}
		</div>
	</div>
</a>

{#snippet Gradient()}
	<div
		class="pointer-events-none absolute inset-0 bg-linear-to-t from-black via-black/75 to-transparent opacity-70 transition-opacity duration-500 group-hover:opacity-80"
	></div>
{/snippet}

{#snippet CtaBtn()}
	<div class="btn btn-circle shadow-lg btn-primary">
		<IconArrowRight class="h-5 w-5" />
	</div>
{/snippet}
